export const state = {
  users: {}
}
